const region = import.meta.env.VITE_PUBLIC_AWS_REGION_NAME;
const userPoolId = import.meta.env.VITE_PUBLIC_AWS_COGNITO_USER_POOL_ID;
const client_id = import.meta.env.VITE_PUBLIC_AWS_COGNITO_APP_CLIENT_ID;
const cognitoEnvironment = import.meta.env.VITE_PUBLIC_AWS_COGNITO_ENVIRONMENT;
const userPoolEndpoint = import.meta.env.VITE_PUBLIC_AWS_USER_POOL_ENDPOINT;
const authority = import.meta.env.VITE_PUBLIC_AWS_COGNITO_AUTHORITY;
const redirect_uri = import.meta.env.VITE_PUBLIC_AWS_COGNITO_REDIRECT_URI;
const response_type = import.meta.env.VITE_PUBLIC_AWS_COGNITO_RESPONSE_TYPE;
const scope = import.meta.env.VITE_PUBLIC_AWS_COGNITO_SCOPE;
const awsconfig = {
    authority,
    client_id,
    redirect_uri,
    response_type,
    userPoolId,
    scope,
};
export { userPoolEndpoint };
export default awsconfig;
